/* global window document */
/* global document: true */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { FlagFilled } from '@ant-design/icons';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'underscore';
import moment from 'moment';
import DOM from './recordDetailView';
import MapPopups from '../MapOld/elements/MapPopups';
import { convertFromSeconds, openStreetView, secondsToHms } from '../../core/utils/functions';
import * as videoActions from '../../core/video/videoActions';
import * as eventsActions from '../../core/events/eventsActions';
import * as deviceActions from '../../core/device/deviceActions';
import {
    calculateSpeedAndUnit, getMapAssetPopupContent, getMapAssetPopupHead,
    setMarkerPopoverToLoading, setMarkerPopoverDetails,
} from '../../core/utils/mapUtils';
import { UnitOfMeasurement, UnitOfSpeed } from '../../types/types';

const { DB_DATE_FORMAT, KM_TO_MILES_FACTOR } = require('../../core/constants').default;

const {
    MapAssetPopupContent,
    MapAssetPopupHead,
} = MapPopups;

class RecordDetailView extends Component {
    constructor(props) {
        super(props);
        this.pdfDocumentRef = React.createRef();
        this.pdfRef = React.createRef();
        this.view = DOM;
        this.googleMapAccess = React.createRef();
        this.cachedVideosRefs = [];
        this.centerMap = {};
        this.eventsInTrip = [];
        this.state = {
            sliderValue: props?.params?.slider_value || props?.selectedRecord?.interval || props?.selectedRecord?.startInterval,
            sliderRangeMinValue: props?.selectedRecord?.startInterval,
            sliderMinValue: props?.selectedRecord?.startInterval,
            sliderRangeMaxValue: props?.selectedRecord?.endInterval,
            sliderMaxValue: props?.selectedRecord?.endInterval,
            selectedVideoChannels: [],
            cachedVideos: [],
            videoMode: 'streaming',
            streamingVideos: false,
            showResetBtn: false,
            setVideoTab: true,
            markerPopover: null,
        };
        this.streamingVideosRefs = [];
        this.videoTimer = null;
    }

    componentDidMount() {
        const {
            selectedRecord, actions, recordInfoFetched, showShareBlock, user,
        } = this.props;
        const canViewLive = user?.permissions?.live_video;

        setTimeout(() => {
            if (selectedRecord) {
                if (recordInfoFetched) {
                    actions.resetEventInfoRequest();
                    setTimeout(() => {
                        if (this.googleMapAccess && this.googleMapAccess.current) {
                            this.googleMapAccess.current.setState({ sliderMaxValue: selectedRecord.endInterval });
                            this.googleMapAccess.current.executeAutoZoom();
                            this.googleMapAccess.current.showGeoFenceOnMap(true);
                        }
                    }, 500);
                }
            }
        }, 2000);

        if (!showShareBlock) {
            setTimeout(() => {
                if (this.googleMapAccess && this.googleMapAccess.current) {
                    this.googleMapAccess.current.refreshMap();
                    this.googleMapAccess.current.executeAutoZoom();
                }
            }, 2000);
        }

        if (!canViewLive) {
            this.setState({ setVideoTab: false, videoMode: 'cached' });
        }

        setMarkerPopoverToLoading(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            selectedRecord, updateMapEventData, actions, recordInfoFetched, videoUrlsError, isFetchingVideoUrls,
            sliderValue, deviceDetailedLocationFetching, deviceDetailedLocationInfo, user,
        } = this.props;
        const { setVideoTab } = this.state;
        const cachedVideos = selectedRecord?.dvrDetails?.cached_videos || [];

        if (setVideoTab && cachedVideos.length > 0) {
            this.setState({ setVideoTab: false, videoMode: 'cached' });
        }

        if (!this.props.recordIsFetching && prevProps.recordIsFetching) {
            setTimeout(() => {
                if (this.googleMapAccess && this.googleMapAccess.current) {
                    const midSliderValue = Math.floor((selectedRecord.endInterval - selectedRecord.startInterval) / 6);
                    this.googleMapAccess.current.setState({
                        sliderValue: sliderValue || (selectedRecord.startInterval + midSliderValue),
                        sliderMinValue: selectedRecord.startInterval,
                        sliderMaxValue: selectedRecord.endInterval,
                        sliderRangeMinValue: selectedRecord.startInterval,
                        sliderRangeMaxValue: selectedRecord.endInterval,
                    });
                    this.googleMapAccess.current.executeAutoZoom();
                    // the value is updated but not trigger re-render, update the state to re-render with latest data
                    this.setState({
                        sliderValue: sliderValue || (selectedRecord.startInterval + midSliderValue),
                        sliderMinValue: selectedRecord.startInterval,
                        sliderMaxValue: selectedRecord.endInterval,
                        sliderRangeMinValue: selectedRecord.startInterval,
                        sliderRangeMaxValue: selectedRecord.endInterval,
                    });
                    this.googleMapAccess.current.showGeoFenceOnMap(true);
                }
            }, 250);
        }

        if (prevProps.selectedRecord && selectedRecord) {
            if (prevProps.selectedRecord.startInterval !== selectedRecord.startInterval) {
                this.setState({ sliderValue: selectedRecord.startInterval });
            }
            if (recordInfoFetched) {
                actions.resetEventInfoRequest();
                setTimeout(() => {
                    if (this.googleMapAccess && this.googleMapAccess.current) {
                        this.googleMapAccess.current.setState({ sliderMaxValue: selectedRecord.endInterval });
                        this.googleMapAccess.current.executeAutoZoom();
                    }
                }, 500);
            }
        }

        if (videoUrlsError && prevProps.videoUrlsError !== videoUrlsError) {
            this.setState({ streamingVideos: false });
        }

        if (!isFetchingVideoUrls && prevProps.isFetchingVideoUrls !== isFetchingVideoUrls) {
            if (this.googleMapAccess?.current) {
                this.googleMapAccess.current.togglePlayPause();
            }
        }

        if (deviceDetailedLocationFetching === false && deviceDetailedLocationInfo !== prevProps.deviceDetailedLocationInfo) {
            const { showLive } = this.googleMapAccess.current.state;
            setMarkerPopoverDetails(this, showLive, user?.profile?.unit_of_measurement_preference);
        }
    }

    renderPdf(toPdf) {
        window.scrollTo(0, 0);
        setTimeout(() => {
            toPdf();
            this.setState({
                parentWidth: parseInt(window?.frameElement?.getAttribute('data-parent-width'), 10) || window.innerWidth,
                parentHeight: parseInt(window?.frameElement?.getAttribute('data-parent-height'), 10) || window.innerHeight,
            });
        }, 2500);
    }

    getSelectedVideosUrl = () => {
        const { actions, selectedRecord } = this.props;
        const { selectedVideoChannels, sliderValue } = this.state;
        const selectedTime = convertFromSeconds(sliderValue).padStart(8, '0');
        const searchChannels = {};
        searchChannels.date_from = `${moment(selectedRecord?.startTimeBST).format(DB_DATE_FORMAT)} ${selectedTime}`; // selectedRecord?.startTimeUTC;
        searchChannels.date_to = selectedRecord?.endTimeBST;
        searchChannels.channels = selectedVideoChannels ? selectedVideoChannels.join(',') : 0;
        searchChannels.device_id = selectedRecord?.dvrDetails?.id || null;
        actions.getChannelsAndVideosRequest(searchChannels);
        this.setState({ streamingVideos: true });
    };

    requestCacheAgain = () => {
        const { actions, selectedRecord, shardId } = this.props;
        const failedVideos = [];
        Object.keys(selectedRecord.dvrDetails.discovered_videos).map((key) => {
            const video = selectedRecord.dvrDetails.discovered_videos[key][0];
            if (video.status == 'not-available') {
                failedVideos.push(video.id);
            }
        });
        if (!isEmpty(failedVideos)) {
            actions.resetTrimAndCacheVideoRequest({ failedVideos });

            setTimeout(() => {
                const params = {};
                params.videoReference = selectedRecord.reference;
                params.shardId = shardId || '1';
                actions.getEventInfoByVideoReferenceRequest(params);
            }, 2000);
        }
    };

    mapDevicePath = (selectedRecord) => {
        const { user, company } = this.props;
        const eventsInTrip = [];
        let foundFirstEvent = false;
        const info = (selectedRecord && selectedRecord.info) || {};
        const path = selectedRecord && selectedRecord.path ? selectedRecord.path.map((event, eventIndex) => {
            let { speed } = event;
            let unit = UnitOfSpeed.Metric;
            if (user && user.profile && user.profile.unit_of_measurement_preference === UnitOfMeasurement.BritishImperial) {
                unit = UnitOfSpeed.BritishImperial;
                speed = Math.floor(speed * 0.62);
            }
            const tempEvent = {};
            tempEvent.showLoading = false;
            tempEvent.showNoData = false;
            tempEvent.time_interval = event.time_interval;
            tempEvent.time = event.time;
            tempEvent.lat = event.lat;
            tempEvent.lng = event.lng;
            tempEvent.record_id = event.id;
            tempEvent.angle = event.angle;
            tempEvent.speed = speed;
            tempEvent.position = 'path';
            tempEvent.title = selectedRecord.info.asset_name;
            tempEvent.registration = selectedRecord.info.registration;
            if ((event.priority === 1 && foundFirstEvent === false) || eventIndex === 0) {
                this.centerMap.lat = parseFloat(event.lat);
                this.centerMap.lng = parseFloat(event.lng);
                if (eventIndex > 0) {
                    foundFirstEvent = true;
                }
            }
            if (event.show_in_events === 1) {
                tempEvent.is_event = true;
                this.centerMap.lat = parseFloat(event.lat);
                this.centerMap.lng = parseFloat(event.lng);
                const iconStyle = {};
                iconStyle.fontSize = '16px';
                iconStyle.color = '#CF2B28';

                tempEvent.position = 'event';
                tempEvent.currentMarker = {};
                let eventTitle = event.event_name;

                if (event.event_type == 253) {
                    if (event.green_driving_type == 0) {
                        eventTitle = 'Eco-friendly driving';
                    } else if (event.green_driving_type == 1) {
                        eventTitle = 'Harsh accelerating';
                    } else if (event.green_driving_type == 2) {
                        eventTitle = 'Harsh braking';
                    } else if (event.green_driving_type == 3) {
                        eventTitle = 'Harsh cornering';
                    }
                }
                eventsInTrip.push({ title: eventTitle, value: moment(event.time).format('DD/MM/YYYY hh:mm:ss') });

                if (event.icon && event.icon !== '') {
                    tempEvent.icon = <LegacyIcon style={iconStyle} type={event.icon} theme="filled" />;
                } else {
                    tempEvent.icon = <FlagFilled style={iconStyle} />;
                }

                tempEvent.title = (
                    <MapAssetPopupHead
                        speed={tempEvent.speed}
                        heading={eventTitle}
                        registration={tempEvent.registration} 
                    />
                );
                tempEvent.content = (
                    <MapAssetPopupContent
                        showLoading={false}
                        showPicture
                        assetPicture={info.asset_picture}
                        userPicture={info.profile_picture}
                        defaultImage={user?.userCompany?.company_image}
                        event_key={eventTitle}
                        event_type={event.event_type}
                        online={event.online}
                        online_status={event.online_status}
                        dateTime={event.time}
                        driver={info.driver}
                        speed={speed}
                        speedUnit={unit}
                        streetViewIconClicked={openStreetView}
                        googleMapAccessRef={this.googleMapAccess}
                        lat={event.lat}
                        lng={event.lng}
                        location_data={event.location_data}
                        user={user}
                        angle={event.angle} 
                        showTimeToDestinationBtn={company && company.features && company.features.find((feature) => feature.id === 'time-to-destination')} />
                );
                tempEvent.markerPopover = tempEvent.content;

                // tempEvent.currentMarker.icon = event.icon && event.icon !== ''
                //     ? (
                //         <Tooltip title={event.event_name}><AntIcon
                //             type={event.icon}
                //             theme="filled"
                //             style={iconStyle} />
                //         </Tooltip>
                //     )
                //     : <AntIcon type="flag" theme="filled" />;
            }
            return tempEvent;
        })
            : [];
        this.eventsInTrip = eventsInTrip;
        return path;
    };

    getAssetCurrentPin = (mappedDevicePath) => {
        const { sliderValue } = this.state;
        const { selectedRecord, user } = this.props;
        const assets = mappedDevicePath.filter((path) => path.time_interval == sliderValue);

        if (assets && assets[0]) {
            const { speed, unit } = calculateSpeedAndUnit(assets[0], user);
            if (user.profile.unit_of_measurement_preference === UnitOfMeasurement.BritishImperial) {
                assets[0].speed = Math.ceil(assets[0].speed * KM_TO_MILES_FACTOR);
            }
            const title = getMapAssetPopupHead(assets[0]);
            const content = getMapAssetPopupContent(this, assets[0], speed, unit, user?.userCompany?.company_image);

            assets[0].arrowIcon = true;
            assets[0].hasEvents = true;
            assets[0].imei = '';
            assets[0].online = 0;
            assets[0].registration = '';
            assets[0].markers = [];
            assets[0].currentMarker = {};
            assets[0].currentMarker.lat = parseFloat(assets[0].lat);
            assets[0].currentMarker.lng = parseFloat(assets[0].lng);
            assets[0].currentMarker.angle = assets[0].angle;
            assets[0].currentMarker.imei = '';
            assets[0].currentMarker.showArrowIcon = true;
            assets[0].currentMarker.speed = speed;
            assets[0].currentMarker.time_interval = assets[0].time_interval;
            assets[0].currentMarker.title = '';
            assets[0].markers[assets[0].time_interval] = {};
            assets[0].markers[assets[0].time_interval].lat = parseFloat(assets[0].lat);
            assets[0].markers[assets[0].time_interval].lng = parseFloat(assets[0].lng);
            assets[0].markers[assets[0].time_interval].record_id = assets[0].record_id;
            assets[0].markers[assets[0].time_interval].angle = assets[0].angle;
            assets[0].markers[assets[0].time_interval].imei = '';
            assets[0].markers[assets[0].time_interval].showArrowIcon = true;
            assets[0].markers[assets[0].time_interval].speed = speed;
            assets[0].markers[assets[0].time_interval].time_interval = assets[0].time_interval;
            assets[0].markers[assets[0].time_interval].title = title;
            assets[0].markers[assets[0].time_interval].content = content;
        }
        return assets;
    };

    getUpdatedTimeVideosStream = (value) => {
        const selectedTime = convertFromSeconds(value).padStart(8, '0');
        const { actions, selectedRecord } = this.props;
        const { selectedVideoChannels } = this.state;
        if (selectedVideoChannels.length > 0) {
            const searchChannels = {};
            searchChannels.date_from = `${moment(selectedRecord?.startTimeUTC).format(DB_DATE_FORMAT)} ${selectedTime}`;
            searchChannels.date_to = selectedRecord?.endTimeBST;
            searchChannels.channels = selectedVideoChannels.length > 0 ? selectedVideoChannels.join(',') : '0';
            searchChannels.device_id = selectedRecord?.dvrDetails?.id || null;
            actions.getChannelsAndVideosRequest(searchChannels);
        }
    };

    onSliderRangeChange = (value, formattedValue, newSliderRangeMinValue, newSliderRangeMaxValue, changedByPlay) => {
        const processStartTime = new Date();
        const {
            sliderValue, sliderRangeMinValue, sliderRangeMaxValue, videoMode,
        } = this.state;
        const { selectedRecord } = this.props;

        if (sliderRangeMinValue != newSliderRangeMinValue || sliderRangeMaxValue != newSliderRangeMaxValue) {
            this.setState({
                sliderRangeMinValue: newSliderRangeMinValue,
                sliderRangeMaxValue: newSliderRangeMaxValue,
                sliderValue: value,
            });
        } else {
            this.setState({ sliderValue: value });
        }
        if (this.videoTimer != null) {
            this.videoTimer = clearTimeout(this.videoTimer);
        }
        if (videoMode == 'streaming' && sliderValue != value && !changedByPlay) {
            this.videoTimer = setTimeout(() => this.getUpdatedTimeVideosStream(value), 1000);
            if (this.googleMapAccess?.current?.state?.showPlayPause) {
                this.googleMapAccess.current.togglePlayPause();
            }
        } else {
            if (changedByPlay) {
                // eslint-disable-next-line no-param-reassign
                value += 1;
            }
            if (videoMode == 'cached') {
                let sliderUpdated = false; // need to only update the slider once
                (this.cachedVideosRefs).forEach((video, videoIndex) => {
                    const videoParts = (video.key).split('#');
                    const startTime = parseInt(videoParts[1], 10);
                    const endTime = startTime + parseInt(videoParts[2], 10);

                    if (video && video.element && video.element.play) {
                        if (this.googleMapAccess?.current?.state?.showPlayPause) {
                            video.element.play();
                        }

                        if (value >= startTime && value <= endTime) {
                            let currentTime = (value - startTime);
                            const sliderCurrentTime = currentTime;

                            let currentVideoOffset = 0;
                            if (video.element.currentTime && changedByPlay) {
                                // adding previous video time offset
                                currentVideoOffset += Math.floor(((video.element.currentTime) - currentTime) * 100) / 100;

                                if (currentVideoOffset > 0) {
                                    currentTime += currentVideoOffset;
                                }
                            }
                            /**
                             * adding current process time offset
                             * by the time the function was called from the map, to now some milliseconds have passed
                             * we need to add this time when setting the new video time
                             */
                            if (changedByPlay) {
                                const processCurrentTime = new Date();
                                const processTimeDif = (processCurrentTime - processStartTime) / 1000;
                                currentTime = Math.floor((currentTime + processTimeDif) * 100) / 100;
                            }

                            // need to update slider value because video player plays faster than slider
                            const sliderVideoDiff = currentTime - sliderCurrentTime;
                            if (!sliderUpdated) {
                                if (sliderVideoDiff >= 3) {
                                    const newSliderValue = (value + sliderVideoDiff);
                                    sliderUpdated = true;
                                    this.setState({ sliderValue: newSliderValue });
                                } else {
                                    sliderUpdated = true;
                                    this.setState({ sliderValue: value });
                                }
                            }
                            video.element.currentTime = currentTime;
                        }
                        if (value < startTime) {
                            video.element.currentTime = startTime - startTime;
                        }
                        if (value > endTime) {
                            video.element.currentTime = endTime - startTime;
                        }
                    }
                });
            } else if (videoMode == 'streaming') {
                let sliderUpdated = false; // need to only update the slider once
                (this.streamingVideosRefs).forEach((video, videoIndex) => {
                    const videoParts = (video.key).split('#');
                    const startTime = parseInt(videoParts[1], 10);
                    const endTime = startTime + parseInt(videoParts[2], 10);

                    if (video && video.element && video.element.play) {
                        let currentTime = (value - startTime);
                        const sliderCurrentTime = currentTime;
                        let currentVideoOffset = 0;

                        if (video.element.currentTime && changedByPlay) {
                            // adding previous video time offset
                            currentVideoOffset = Math.floor(((video.element.currentTime) - currentTime) * 100) / 100;
                            currentTime += currentVideoOffset;
                        }

                        // need to update slider value because stream plays slower than slider
                        const sliderVideoDiff = currentTime - sliderCurrentTime;
                        if (!sliderUpdated) {
                            if (Math.abs(sliderVideoDiff) >= 3) {
                                const newSliderValue = (value + sliderVideoDiff);
                                sliderUpdated = true;
                                this.setState({ sliderValue: newSliderValue });
                            } else {
                                sliderUpdated = true;
                                this.setState({ sliderValue: value });
                            }
                        }
                    } else {
                        // TODO Howen player doesn't have video controls
                        // eslint-disable-next-line no-lonely-if
                        if (!sliderUpdated) {
                            sliderUpdated = true;
                            this.setState({ sliderValue: value });
                        }
                    }
                });
            }
        }
    };

    handlePause = () => {
        const { videoMode } = this.state;
        if (videoMode == 'cached') {
            (this.cachedVideosRefs).forEach((video) => {
                if (video && video.element && video.element.pause) {
                    video.element.pause();
                }
            });
        }
        if (videoMode == 'streaming') {
            (this.streamingVideosRefs).forEach((video) => {
                if (video && video.element && video.element.pause) {
                    video.element.pause();
                }
            });
        }
    };

    handleResume = () => {
        const { videoMode } = this.state;

        if (videoMode == 'streaming') {
            (this.streamingVideosRefs).forEach((video) => {
                if (video && video.element && video.element.play) {
                    video.element.play();
                }
            });
        }
    };

    requestCacheAndTrimVideos = () => {
        const { sliderRangeMinValue, sliderRangeMaxValue, selectedVideoChannels } = this.state;
        const { selectedRecord, actions } = this.props;

        const deviceId = selectedRecord?.dvrDetails?.id || null;
        const assetId = selectedRecord?.info?.asset_id || null;
        const userid = selectedRecord?.info?.user_id || null;
        const videoDate = selectedRecord?.startTimeUTC || null;
        const location = selectedRecord?.location || null;

        actions.trimAndCacheVideoRequest({
            deviceId,
            assetId,
            videoDate,
            selectedVideoChannels,
            sliderRangeMinValue,
            sliderRangeMaxValue,
            location,
        });
    };

    handleForward = (option) => {
        const { selectedRecord, maxAllowedTimeline, onForward } = this.props;
        const eventDate = moment(selectedRecord?.startTimeUTC).format('YYYY:MM:DD');
        let sliderMinValue = selectedRecord?.startInterval;
        let sliderMaxValue = selectedRecord?.endInterval;
        sliderMaxValue += option.value;

        const timelineDuration = sliderMaxValue - sliderMinValue;
        if (timelineDuration > maxAllowedTimeline) {
            const timelineDiff = timelineDuration - maxAllowedTimeline;
            sliderMinValue += timelineDiff;
        }

        const startTime = `${eventDate} ${secondsToHms(sliderMinValue, 'time')}`;
        const endTime = `${eventDate} ${secondsToHms(sliderMaxValue, 'time')}`;
        this.setState({ showResetBtn: true });
        onForward(startTime, endTime);
    };

    handleRewind = (option) => {
        const { selectedRecord, maxAllowedTimeline, onRewind } = this.props;
        const eventDate = moment(selectedRecord?.startTimeUTC).format('YYYY:MM:DD');
        let sliderMinValue = selectedRecord?.startInterval;
        let sliderMaxValue = selectedRecord?.endInterval;
        sliderMinValue -= option.value;

        const timelineDuration = sliderMaxValue - sliderMinValue;
        if (timelineDuration > maxAllowedTimeline) {
            const timelineDiff = timelineDuration - maxAllowedTimeline;
            sliderMaxValue -= timelineDiff;
        }

        const startTime = `${eventDate} ${secondsToHms(sliderMinValue, 'time')}`;
        const endTime = `${eventDate} ${secondsToHms(sliderMaxValue, 'time')}`;
        this.setState({ showResetBtn: true });
        onRewind(startTime, endTime);
    };

    handleIncreaseOptionCallback = (option) => {
        const { selectedRecord, onIncreaseOptionClick } = this.props;
        const { sliderValue } = this.state;
        const sliderMinValue = sliderValue - option.value;
        const sliderMaxValue = sliderValue + option.value;
        const eventDate = moment(selectedRecord?.startTimeUTC).format('YYYY:MM:DD');
        const startTime = `${eventDate} ${secondsToHms(sliderMinValue, 'time')}`;
        const endTime = `${eventDate} ${secondsToHms(sliderMaxValue, 'time')}`;
        this.setState({ showResetBtn: true });
        onIncreaseOptionClick(startTime, endTime, sliderValue);
    };

    handleReset = () => {
        const { onReset } = this.props;
        this.setState({ showResetBtn: false });
        onReset();
    };

    render() {
        return this.view();
    }
}

RecordDetailView.defaultProps = {
    selectedRecord: {},
    googleMapApi: null,
    eventsData: [],
    allowActions: true,
    onForward: () => { },
    onRewind: () => { },
    onIncreaseOptionClick: () => { },
    onReset: () => { },
    showStreamingSectionOnLoad: false,
    maxAllowedTimeline: 60 * 30,
    sliderValue: null,
    showDownloadIframe: true,
};

RecordDetailView.propTypes = {
    selectedRecord: PropTypes.object,
    googleMapApi: PropTypes.object,
    eventsData: PropTypes.array,
    allowActions: PropTypes.bool,
    onForward: PropTypes.func,
    onRewind: PropTypes.func,
    onReset: PropTypes.func,
    onIncreaseOptionClick: PropTypes.func,
    showStreamingSectionOnLoad: PropTypes.bool,
    maxAllowedTimeline: PropTypes.number,
    sliderValue: PropTypes.number,
    showDownloadIframe: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        user: state.user,
        searchedSingleVideoChannels: state.video.searchedSingleVideoChannels,
        isFetchingVideoUrls: state.video.isFetchingVideoUrls,
        videoUrlsError: state.video.error,
        recordInfoFetched: state.records.recordInfoFetched,
        recordIsFetching: state.records.isFetching,
        deviceDetailedLocationFetching: state.device.deviceDetailedLocationFetching,
        deviceDetailedLocationInfo: state.device.deviceDetailedLocationInfo,
        shardId: state.global.shardId,
        selectedRecord: state.records.selectedRecord,
        company: state.user.userCompany,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...videoActions,
                ...eventsActions,
                ...deviceActions,
            },
            dispatch,
        ),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RecordDetailView);
